module.exports = __webpack_public_path__ + "static/media/end-quote.a3fbd395.svg";